import {SurveyId} from 'common/models/survey';

export interface ShareProps {
    surveyId: SurveyId;
    stats: boolean;
    results: boolean;
    answerKey: string;
    scores?: string;
    totalScores?: string;
    title?: string;
    surveyName?: string;
    imageLink?: string;
}

export enum ShareType {
    Form = 'form',
    Stats = 'stats',
    Results = 'results',
}

export interface ShareInfo {
    blockTitle: string;
    link: string;
    text: string;
}
